module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.startTime,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                ~\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "value": _vm.endTime,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": _vm.getGtyData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('h2', [_vm._v("经营关键指标")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "half-container"
  }, [_c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("销量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.formData.totalSoldCount))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "half-container"
  }, [_c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("销售额(元)")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.formData.totalSales))])])])])])])]), _vm._v(" "), _c('h2', [_vm._v("运营数据曲线")]), _vm._v(" "), _c('div', {
    staticClass: "data-container margin-top"
  }, [_c('h3', {
    staticClass: "projectLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'gtyProgramData'
      }
    }
  }, [_vm._v("查看项目数据")])], 1), _vm._v(" "), _c('div', {
    staticClass: "data-type-container"
  }, [_c('div', [_c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'soldCount'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('soldCount')
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'sales'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('sales')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'rejectRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('rejectRatio')
      }
    }
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'refundRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refundRatio')
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'payRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('payRatio')
      }
    }
  }, [_vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'uv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('uv')
      }
    }
  }, [_vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "charts",
    attrs: {
      "id": "charts"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("选择时间：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("销量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("销售额(元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("商家拒单率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("用户退款率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("访购率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("访客数")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c697f674","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gtyDataCenter/operationData.vue
// module id = 1004
// module chunks = 0